export const apiUrl = "https://dev-api-multichannel.voip24h.vn/";
//export const apiUrl ="https://dev-api-multichannel.voip24h.vn/";
export const apiCheckSip = "http://14.225.251.99/";
export const apiAccessOAZalo = "https://oauth.zaloapp.com/v4/";
export const tesst =
    "http://cloud.voip24h.vn/media/127.0.0.1/192.168.2.51/2023";
export const apiLivechat = "https://dev-api-multichannel.voip24h.vn/livechat/api/";
//export const apiZalo="https://api-multichannel.voip24h.vn/zalo/api/";
export const apiZalo = `${process.env.REACT_APP_HOST_URL}zalo/api/`;
export const apiFacebook = `${process.env.REACT_APP_HOST_URL}facebook/api/`;
export const apiOAFacebook = "https://oauth.zaloapp.com/v4/oa/access_token";
export const appIdZalo = "2084835988266192116";
export const secretKeyZalo = "Cj4QPDz2SxL1Frse2Yxo";
//export const hostSocket = 'http://localhost:3056'
//export const hostSocket = 'https://dev-socket-dakenh.voip24h.vn'
//export const hostSocket = 'https://api-dakenh.onrender.com';
export const hostSocket = "https://dev-socket-dakenh.voip24h.vn";
